export default {
	_event:   { type:Object,   required:true },
	_cbOK:    { type:Function, required:false, default:()=>{} },
	_cbERR:   { type:Function, required:false, default:()=>{} },
	_htmlFormModel: Array,
	_userID:        Number,
	_memberID:      Number,
	_ppntID:        Number,
	_msgOK:      { type:String, required:false, default:'Вы успешно зарегистрированы на мероприятие!' },
	_submitText: { type:String, required:false, default:'Отправить' },
}
